import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { TableComponent } from "src/app/table.component";
import { ComprehensiveOrderSummaryService } from "src/services/reports/comprehensive-order-summary.service";

export class OrderSummary {
  orderDate: Date;
  orders: number;
  customers: number;
  basePremium: number;
  fees: number;
  totalPremium: number;
}

@Component({
  selector: "app-comprehensive-order-summary-reports",
  templateUrl: "./comprehensive-order-summary-reports.component.html",
  styleUrls: ["./comprehensive-order-summary-reports.component.css"],
})
export class ComprehensiveOrderSummaryReportsComponent
  extends TableComponent<OrderSummary>
  implements OnInit
{
  pageTitle = "Order Summary Report";
  startDate: Date;
  endDate: moment.Moment;
  get EndDate() {
    return this.endDate;
  }
  set EndDate(value) {
    if (value) {
      this.endDate = value.endOf("day");
    }
  }

  displayedColumns: string[] = [
    "orderDate",
    "orders",
    "customers",
    "basePremium",
    "addOn",
    "fees",
    "totalPremium",
    "netAmount",
  ];

  orderList: OrderSummary[] = [];

  constructor(private reportService: ComprehensiveOrderSummaryService) {
    super(reportService);
  }

  getCount(): any {
    const data = {
      startDate: this.startDate,
      endDate: this.endDate,
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      take: this.paginator.pageSize,
    };
    return this.reportService.getCount(data);
  }

  getData(): any {
    return {
      startDate: this.startDate,
      endDate: this.endDate,
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      take: this.paginator.pageSize,
      orderBy: this.sort.active,
      orderByDescending: this.sort.direction === "desc",
    };
  }

  getDataByFilter() {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  downloadXLS(isXLS: boolean) {
    const data = {
      startDate: this.startDate,
      endDate: this.endDate,
      skip: 0,
      take: 2147483647,
      asXLS: isXLS,
    };

    this.reportService.downloadReport(data);
  }
}
